/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Group_Saved_SuccessInputs */



/**
* | output |
* | --- |
* | "Group saved successfully" |
*
* @param {Team_Manager_Group_Saved_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_group_saved_success = /** @type {((inputs?: Team_Manager_Group_Saved_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Group_Saved_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe enregistré avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gruppe erfolgreich gespeichert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppo salvato con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группа успешно сохранена")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo guardado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("群组已成功保存")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループが正常に保存されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह सफलतापूर्वक बच गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo salvo com sucesso")
	return /** @type {LocalizedString} */ ("Group saved successfully")
});